const { getListArgs } = require('../../tools/sql-tools')

const getLocationByCustomerIdQuery = (paymentProvider, customerId) => {
  return {
    query: `
      select
        l.fsid,
        pc.location_id,
        ql."company_code",
        ql.quickbooks_customer_id as customer_id
      from avocado.payment_customers pc
      left join avocado.data_location l on pc.location_id = l."uuid" 
      left join avocado.data_quickbookslocation ql on ql.location_id = l.uuid
      where pc.payment_provider = $1 and pc.external_id = $2`,
    values: [paymentProvider, customerId],
    queryName: 'getLocationByCustomerIdQuery'
  }
}

const getLocationByUuidQuery = (locationUuid) => {
  return {
    query: `
      select
        l.fsid,
        l.uuid as location_id,
        ql."company_code",
        ql.quickbooks_customer_id as customer_id
      from avocado.data_location l 
      left join avocado.data_quickbookslocation ql on ql.location_id = l.uuid
      where l.uuid = $1
    `,
    values: [locationUuid],
    queryName: 'getLocationByUuidQuery'
  }
}

const getAccountPaymentPlansQuery = (locationId, companyCode, accountIds) => {
  const { args } = getListArgs(accountIds, 3)
  return {
    query: `
      select
        p.id,
        p.quickbooks_account_id,
        p.company_code
      from avocado.data_paymentplan p
      where p.location_id = $1 and p.company_code = $2 and p.quickbooks_account_id in (${args})
    `,
    values: [locationId, companyCode, ...accountIds]
  }
}

module.exports = {
  getLocationByCustomerIdQuery,
  getAccountPaymentPlansQuery,
  getLocationByUuidQuery
}
